import { Decorators, EntityGrid, EnumFormatter, faIcon } from "@serenity-is/corelib";
import { DataAuditLogDialog } from "./DataAuditLogDialog";
import { DataAuditLogColumns, DataAuditLogRow, DataAuditLogService, DataAuditLogType } from "../ServerTypes/Pro";

@Decorators.registerClass('Serenity.Pro.DataAuditLog.DataAuditLogGrid')
export class DataAuditLogGrid<P = {}> extends EntityGrid<DataAuditLogRow, P> {
    protected getColumnsKey() { return DataAuditLogColumns.columnsKey; }
    protected getDialogType() { return DataAuditLogDialog; }
    protected getRowDefinition() { return DataAuditLogRow; }
    protected getService() { return DataAuditLogService.baseUrl; }

    protected getButtons() {
        return [];
    }

    protected getColumns() {
        var columns = new DataAuditLogColumns(super.getColumns());

        columns.LogType && (columns.LogType.format = ctx => {
            var icon: string = null;
            switch (ctx.value) {
                case DataAuditLogType.Delete:
                    icon = faIcon("times", "red");
                    break;
                case DataAuditLogType.Insert:
                    icon = faIcon("plus", "green");
                    break;
                case DataAuditLogType.Update:
                    icon = faIcon("edit", "orange");
                    break;
            }

            return (<>{icon && <i class={icon} />} {EnumFormatter.format(DataAuditLogType, ctx.value)}</>);
        });

        return columns.valueOf();
    }
}
